import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

export const InternalBillingExplorerTotalNoDataView: FC = () => (
  <Stack
    border={1}
    spacing={2}
    height="100%"
    alignItems="center"
    borderColor={grey[300]}
    justifyContent="center"
  >
    <Typography variant="body2" fontWeight="medium">
      No data available to display.
    </Typography>
    <Typography variant="body2">
      There might be no data for the selected filters or an error occurred while
      loading the data.
    </Typography>
  </Stack>
);
